import { increaseCounter } from './legends.utils';
import { SalesChannelLegendLabel } from './SalesChannelLegendLabel';

export function SalesByTopChannelsLegend() {
  return (canvasContext) => {
    const { height, innerWidth, series, margin } = canvasContext;

    const legendWidth = series.reduce((total, serie) => total + increaseCounter(serie.id), 0);
    const centeredWidth = (innerWidth - legendWidth - margin.left + margin.right) / 2;
    let xCounter = 0;

    return (
      <g x={0} y={0} height={24} width={innerWidth} transform={`translate(0 ${height - 24})`}>
        <g transform={`translate(${centeredWidth} 0)`}>
          {series.toReversed().map((serie) => {
            const label = <SalesChannelLegendLabel x={xCounter} label={serie.id} color={serie.color} key={serie.id} />;
            xCounter += increaseCounter(serie.id);
            return label;
          })}
        </g>
      </g>
    );
  };
}
